import * as React from "react";
import { useContext } from "react";
import { Input } from "reactstrap";
import type { InputProps, InputType } from "reactstrap/lib/Input";
import FormLabelRenderer from "./FormLabelRenderer";
import FormRenderer, { type IFormRendererProps } from "./FormRenderer";

export const InputRendererContext: React.Context<InputProps> =
  React.createContext({});

export type IInputRendererProps<T> = IFormRendererProps & InputProps;

export default function InputRenderer<T>({
  input,
  meta,
  label,
  hideMessages,
  children,
  type: typeProp,
  ...rest
}: IInputRendererProps<T>) {
  const type = typeProp as InputType;
  const { error, submitting, pristine } = meta;
  const contextProps = useContext(InputRendererContext);
  const render = (placeholderText?: string) => (
    <Input
      {...input}
      {...rest}
      {...contextProps}
      placeholder={placeholderText}
      type={type}
      invalid={!pristine && !!error}
      disabled={rest.disabled || submitting}
    >
      {children}
    </Input>
  );

  return (
    <FormRenderer
      input={input}
      meta={meta}
      label={label}
      type={type}
      hideMessages={hideMessages}
    >
      {type === "checkbox" || type === "radio" ? (
        <>
          {render()}

          {label}
        </>
      ) : (
        FormLabelRenderer(label, render)
      )}
    </FormRenderer>
  );
}
